<template>
  <div class="footer-background">
    <b-container>
      <b-row>
        <b-col cols="8">
          <p>2020 BRASOV TRAIL ADVENTURES ®</p>
        </b-col>
        <b-col cols="4" style="text-align: right">
          <p>
            <span>
              <a href="https://www.facebook.com/btahammocks/" target="_blank">
                <img :src="FacebookLogo" class="contact facebook" />
              </a>

              <a href="https://www.instagram.com/hamac_brasov/" target="_blank">
                <img :src="InstagramLogo" class="contact" />
              </a>
            </span>
          </p>
        </b-col>
      </b-row>
        <span class="credits">Proudly made by <a href="https://raluca.marin.rocks/" target="_blank">Raluca Marin</a></span>
    </b-container>
  </div>
</template>

<script>
import FacebookLogo from "./../assets/facebook.svg";
import InstagramLogo from "./../assets/instagram.svg";

export default {
  name: "Footer",

  computed: {
    FacebookLogo() {
      return FacebookLogo;
    },
    InstagramLogo() {
      return InstagramLogo;
    },
  },
};
</script>

<style scoped>
.footer-background {
  background-color: #f6f6f6;
  padding: 25px 0px;
}

.footer-background p {
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 0;
  letter-spacing: 0.5px;
  font-weight: 300;
}

.footer-background h4 {
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0;
}

.contact {
  width: 30px;
  margin: 0 5px;
}

.facebook {
  border-radius: 7px;
}

.credits {
  font-size: 10px;
}

.credits a {
  color: #f2a9a4;
}
</style>
